import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ragSimilar } from "../../service/ragSearch";

// Series navigation + "More like this" rail for a class page. Same-series classes are
// suppressed from the rail server-side (the series has its own prev/next here); the rail
// is for discovery OUTSIDE the series. Hides itself when there's nothing to show (404 /
// no profile and no series).
export default function SimilarClasses({ classId, limit = 8 }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!classId) return undefined;
    let active = true;
    ragSimilar(classId, limit)
      .then((d) => {
        if (active) setData(d);
      })
      .catch(() => {
        if (active) setData(null);
      });
    return () => {
      active = false;
    };
  }, [classId, limit]);

  if (!data) return null;
  const series = data.series;
  const classes = data.classes || [];
  if (!series && classes.length === 0) return null;

  return (
    <div className="mt-10">
      {series && (
        <div className="mb-6 rounded-lg bg-[#D2D6DC] bg-opacity-[0.4] p-4">
          <div className="text-sm text-primaryDark opacity-80 mb-2">
            {typeof series.position === "number"
              ? `Part ${series.position} of ${series.total} in `
              : "In the series "}
            <Link
              to={`/series/${series.permalink ?? series.series_id}`}
              className="font-semibold text-primaryBlue hover:underline"
            >
              {series.title}
            </Link>
          </div>
          <div className="flex justify-between gap-4">
            {series.prev ? (
              <Link
                to={`/${series.prev.permalink ?? series.prev.class_id}`}
                className="text-primaryDark hover:text-primaryBlue"
              >
                {`← ${series.prev.title}`}
              </Link>
            ) : (
              <span />
            )}
            {series.next ? (
              <Link
                to={`/${series.next.permalink ?? series.next.class_id}`}
                className="text-right text-primaryDark hover:text-primaryBlue"
              >
                {`${series.next.title} →`}
              </Link>
            ) : null}
          </div>
        </div>
      )}
      {classes.length > 0 && (
        <>
          <div className="font-bold text-xl text-primaryDark mb-3">More like this</div>
          <ul className="space-y-3">
            {classes.map((c) => (
              <li key={c.class_id}>
                <Link
                  to={`/${c.permalink ?? c.class_id}`}
                  className="block rounded-lg bg-[#D2D6DC] bg-opacity-[0.4] p-3 hover:bg-opacity-[0.6] transition"
                >
                  <div className="font-semibold text-primaryDark">{c.title}</div>
                  {c.summary && (
                    <div className="text-sm text-primaryDark opacity-80 mt-1">
                      {c.summary}
                    </div>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
